import { render, staticRenderFns } from "./AddTextareaBox.vue?vue&type=template&id=d6a61922&"
import script from "./AddTextareaBox.vue?vue&type=script&lang=js&"
export * from "./AddTextareaBox.vue?vue&type=script&lang=js&"
import style0 from "./AddTextareaBox.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddTextareaBox.vue"
export default component.exports